// ─── TIME CONSTANTS ───────────────────────────────────────
export const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const CURRENT_YEAR = new Date().getFullYear();
export const CURRENT_MONTH = new Date().getMonth();

// ─── DEFAULT GRADES ──────────────────────────────────────
export const DEFAULT_GRADES = [
  {id:1,code:'NUR',name:'Nursery',numeric:0},
  {id:2,code:'KG',name:'Kindergarten',numeric:0},
  {id:3,code:'G1',name:'Grade 1',numeric:1},
  {id:4,code:'G2',name:'Grade 2',numeric:2},
  {id:5,code:'G3',name:'Grade 3',numeric:3},
  {id:6,code:'G4',name:'Grade 4',numeric:4},
  {id:7,code:'G5',name:'Grade 5',numeric:5},
  {id:8,code:'G6',name:'Grade 6',numeric:6},
  {id:9,code:'G7',name:'Grade 7',numeric:7},
  {id:10,code:'G8',name:'Grade 8',numeric:8},
  {id:11,code:'G9',name:'Grade 9',numeric:9},
  {id:12,code:'G10',name:'Grade 10',numeric:10},
  {id:13,code:'G11',name:'Grade 11 / F.A Part 1',numeric:11},
  {id:14,code:'G12',name:'Grade 12 / F.A Part 2',numeric:12},
  {id:15,code:'G13',name:'Grade 13 / B.A',numeric:13},
];

// ─── PALETTES ────────────────────────────────────────────
// The first palette is the default for every new device and school.
export const PALETTES = [
  {id:'classic-light',name:'Classic Light',description:'Light sidebar, indigo accent',preview:['#fafaff','#6366f1','#f7f8fc','#ffffff'],vars:{'--primary':'#6366f1','--primary-light':'#818cf8','--primary-dark':'#4f46e5','--sidebar-bg':'#fafaff','--sidebar-text':'#64748b','--sidebar-active':'#6366f1','--bg':'#f7f8fc','--card-bg':'#ffffff','--text-primary':'#1e1b3a','--text-secondary':'#64748b','--border':'#ececf5','--gradient':'linear-gradient(135deg,#6366f1,#8b5cf6)'}},
  {id:'ivory-gold',name:'Ivory Gold',description:'Warm ivory with antique gold',preview:['#1f1a14','#9a7433','#f7f3ea','#fffdf8'],vars:{'--primary':'#8c6a2e','--primary-light':'#b08d57','--primary-dark':'#6e5223','--sidebar-bg':'#1f1a14','--sidebar-text':'#cbbd9f','--sidebar-active':'#9a7433','--bg':'#f7f3ea','--card-bg':'#fffdf8','--text-primary':'#2a2217','--text-secondary':'#75695a','--border':'#ebe2d0','--gradient':'linear-gradient(135deg,#8c6a2e,#c19a5b)'}},
  {id:'sapphire-gradient',name:'Sapphire',description:'Rich blue gradient',preview:['#172554','#3b82f6','#eff6ff','#ffffff'],vars:{'--primary':'#1d4ed8','--primary-light':'#3b82f6','--primary-dark':'#1e3a8a','--sidebar-bg':'#172554','--sidebar-text':'#93c5fd','--sidebar-active':'#1d4ed8','--bg':'#eff6ff','--card-bg':'#ffffff','--text-primary':'#172554','--text-secondary':'#64748b','--border':'#bfdbfe','--gradient':'linear-gradient(135deg,#1d4ed8,#3b82f6)'}},
  {id:'midnight-blue',name:'Midnight Blue',description:'Professional & sleek',preview:['#1a1f3a','#4f6ef7','#f0f4ff','#ffffff'],vars:{'--primary':'#4f6ef7','--primary-light':'#7c94fa','--primary-dark':'#3451d1','--sidebar-bg':'#1a1f3a','--sidebar-text':'#8892b0','--sidebar-active':'#4f6ef7','--bg':'#f0f4ff','--card-bg':'#ffffff','--text-primary':'#1a1f3a','--text-secondary':'#64748b','--border':'#e2e8f0','--gradient':'linear-gradient(135deg,#4f6ef7,#7c94fa)'}},
  {id:'carbon',name:'Carbon',description:'Minimalist dark',preview:['#111111','#71717a','#18181b','#27272a'],vars:{'--primary':'#52525b','--primary-light':'#71717a','--primary-dark':'#3f3f46','--sidebar-bg':'#09090b','--sidebar-text':'#a1a1aa','--sidebar-active':'#52525b','--bg':'#18181b','--card-bg':'#27272a','--text-primary':'#fafafa','--text-secondary':'#a1a1aa','--border':'#3f3f46','--gradient':'linear-gradient(135deg,#52525b,#71717a)'}},
  {id:'dark-pro',name:'Dark Pro',description:'Sleek dark mode',preview:['#0f172a','#6366f1','#1e293b','#334155'],vars:{'--primary':'#6366f1','--primary-light':'#818cf8','--primary-dark':'#4f46e5','--sidebar-bg':'#020617','--sidebar-text':'#94a3b8','--sidebar-active':'#6366f1','--bg':'#0f172a','--card-bg':'#1e293b','--text-primary':'#f1f5f9','--text-secondary':'#94a3b8','--border':'#334155','--gradient':'linear-gradient(135deg,#6366f1,#818cf8)'}},
];

// ─── DEFAULT SETTINGS ────────────────────────────────────
export const DEFAULT_SETTINGS = {
  schoolId: null,
  schoolName: 'My School', schoolCity: '', principalName: '', phone: '', email: '', address: '',
  rollFormat: 'CLASS-###', familyIdFormat: 'FAM-####', admissionPrefix: 'ADM',
  rollNumberSchema: 'class', rollSchoolPrefix: '',
  rollResetOnPromotion: true,
  statuses: ['Active','Inactive','Left','Transferred','Expelled','On Leave','Passed Out'],
  religions: ['Islam','Christianity','Hinduism','Other'],
  nationalities: ['Pakistani','Afghan','Other'],
  feeHeads: [
    {id:1,name:'Tuition Fee',type:'monthly',required:true},
    {id:2,name:'Admission Fee',type:'onetime',required:false},
    {id:3,name:'Exam Fee',type:'termly',required:false},
    {id:4,name:'Transport Fee',type:'monthly',required:false},
    {id:5,name:'Library Fee',type:'yearly',required:false},
    {id:6,name:'Computer Fee',type:'monthly',required:false},
  ],
  classFeeTemplates: {},
  openingBalances: {},
  castList: ['Arain','Rajput','Jat','Sheikh','Syed','Ansari','Mughal','Other'],
  occupations: ['Farmer','Business','Government Job','Private Job','Teacher','Doctor','Labour','Other'],
  bloodGroups: ['A+','A-','B+','B-','AB+','AB-','O+','O-','Unknown'],
  classes: DEFAULT_GRADES.map(g => g.name),
  sections: ['A','B','C','D'],
  grades: DEFAULT_GRADES,
  challanSettings: {
    dueDateDay: 10, fineEnabled: false, finePerDay: 10,
    bankName: '', bankAccount: '', bankBranch: '',
    challanNote: 'Please pay before due date to avoid fine.',
    paymentMethods: ['Cash','JazzCash','Bank Transfer'],
    partialPaymentAllowed: true,
    orientation: 'portrait',
  },
  paletteId: 'classic-light',
  themeVars: PALETTES[0].vars,
  receiptSettings: {
    paperSize: 'thermal', defaultAction: 'preview', autoPrint: false, printerName: '',
    showQR: false, showSignature: true, showAmountInWords: false,
    quotationTitle: 'Quotation', receiptTitle: 'Fee Receipt', salesReceiptTitle: 'Sales Receipt',
    showSchoolAddress: true, showSchoolPhone: true, footerNote: 'Thank you!',
  },
  displayOptions: {
    showRollInTable: true, showAdmNoInTable: true, showFatherInTable: true,
    showPhoneInTable: true, showFeeInTable: true, fontScale: 'normal',
    dateFormat: 'DD/MM/YYYY', currency: 'Rs',
  },
};

// ─── INITIAL DATA ────────────────────────────────────────
export const INITIAL_VENDORS = [
  {id:1,name:'Al-Rehman Stationers',contact:'Khalid Ahmed',phone:'0300-1111111',address:'Main Bazar',email:'',balance:0,notes:'Regular supplier'},
  {id:2,name:'Punjab Book Depot',contact:'Amjad Ali',phone:'0301-2222222',address:'Railway Road',email:'',balance:5000,notes:'Books and stationery'},
  {id:3,name:'City Furniture',contact:'Rashid Mehmood',phone:'0302-3333333',address:'GT Road',email:'',balance:0,notes:'Furniture supplier'},
];

export const INITIAL_PRODUCTS = [
  {id:1,name:'A4 Notebook',category:'Stationery',unit:'piece',buyPrice:40,sellPrice:60,stock:200,minStock:50,vendorId:1,saleable:true,barcode:''},
  {id:2,name:'Blue Pen',category:'Stationery',unit:'piece',buyPrice:10,sellPrice:15,stock:500,minStock:100,vendorId:1,saleable:true,barcode:''},
  {id:3,name:'School Uniform (Full)',category:'Uniform',unit:'set',buyPrice:800,sellPrice:1200,stock:50,minStock:10,vendorId:2,saleable:true,barcode:''},
  {id:4,name:'Geometry Box',category:'Stationery',unit:'piece',buyPrice:80,sellPrice:120,stock:100,minStock:20,vendorId:1,saleable:true,barcode:''},
];

export const INITIAL_ASSETS = [
  {id:1,name:'Desktop Computer',category:'Electronics',quantity:5,purchaseDate:'2023-01-15',purchasePrice:80000,usefulLife:5,location:'Computer Lab',condition:'Good',vendorId:3,notes:''},
  {id:2,name:'Wooden Desk',category:'Furniture',quantity:20,purchaseDate:'2022-06-01',purchasePrice:15000,usefulLife:10,location:'Classrooms',condition:'Good',vendorId:3,notes:''},
];
